const Header = ()=>{
    return (
        <div className="app-header">
            <h1>Notes List</h1>
        </div>
    );
};


export default Header;